<template>
  <import-charge-tab lob="AE" />
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'

export default {
  name: 'ImportChargeAE',
  components: { importChargeTab }
}
</script>
